import Registry from 'live/services/registry'

type PurgeExtraActionsEntry = {
    label: string
    callback: () => void
}

const PurgeExtraActionsRegistry = new Registry<PurgeExtraActionsEntry>()
export default PurgeExtraActionsRegistry
